import { render } from "./Deploy.vue?vue&type=template&id=3f552a68"
import script from "./Deploy.vue?vue&type=script&lang=ts"
export * from "./Deploy.vue?vue&type=script&lang=ts"
script.render = render

export default script